<template>
  <div>
    <template v-if="$vuetify.breakpoint.mdAndDown">
      <v-menu
        v-model="isMenuOpen"
        offset-y
        :close-on-content-click="false"
        :close-on-click="false"
        :close-on-scroll="false"
        transition="scale-transition"
        max-width="240"
        min-width="200"
        attach="body"
        eager
        content-class="limit-menu-fixed limit-menu"
      >
        <template v-slot:activator="{ on, attrs }">
          <div class="d-flex align-center" v-bind="attrs" v-on="on" @click="onMobileClick">
            <div class="limit-avatar-wrapper ms-2 me-1">
              <v-avatar
                size="40"
                class="elevation-2 cursor-pointer"
                :color="
                  showLimitLoading || clickLimitStatus
                    ? 'primary'
                    : $store.state.riskDur == 0
                    ? 'success'
                    : 'tertiary'
                "
              >
                <v-icon size="30" color="white">
                  {{ icons.mdiFinance }}
                </v-icon>
              </v-avatar>
              <span class="limit-overlay">LİMİT</span>
            </div>
          </div>
        </template>
        <v-card elevation="3" rounded="lg" class="py-2 px-3 limit-card">
          <div class="text-caption text--secondary text-center">Kalan Limit</div>
          <div class="limit-row mt-1">
            <div class="font-weight-bold limit-value">
              {{ $store.state.riskTutar | currency({ fractionCount: 0 }) }}
            </div>
            <v-progress-circular
              v-if="showLimitLoading || clickLimitStatus"
              indeterminate
              color="primary"
              size="16"
              width="2"
              class="limit-spinner"
            />
          </div>
        </v-card>
      </v-menu>
    </template>
    <template v-else>
      <v-btn
        :large="true"
        class="ml-3"
        style="height: 56px !important"
        depressed
        rounded
        outlined
        :loading="clickLimitStatus"
        :color="
          showLimitLoading || clickLimitStatus ? 'primary' : $store.state.riskDur == 0 ? 'success' : 'tertiary'
        "
        dark
        @click="clickLimit"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" :size="36" class="me-2">
              {{ icons.mdiFinance }}
            </v-icon>
          </template>
          <span v-if="showLimitLoading">Kalan Limit: Yükleniyor</span>
          <span v-else
            >Kalan Limit:
            {{ $store.state.riskTutar | currency({ fractionCount: 0 }) }}</span
          >
        </v-tooltip>
        <div class="text-left">
          <div class="text-subtitle-1 text-capitalize" style="line-height: 1.25">
            <span v-if="showLimitLoading">Yükleniyor</span>
            <span v-else>{{ $store.state.riskTutar | currency({ fractionCount: 0 }) }}</span>
          </div>
          <div class="text--secondary font-weight-regular" style="font-size: 10px">Kalan Limit</div>
        </div>
      </v-btn>
    </template>
  </div>
</template>

<script>
import { computed, ref, watch } from "@vue/composition-api";
import store from "@/store";
import { useRouter } from "@core/utils";
import { mdiFinance } from "@mdi/js";
export default {
  setup() {
    const { route } = useRouter();
    const clickLimitStatus = ref(false);
    const isMenuOpen = ref(false);
    let autoCloseTimer = null;

    const showLimitLoading = computed(
      () => store.state.riskLoading && route.value.name === "order-to"
    );

    watch(isMenuOpen, (val) => {
      if (val) {
        if (autoCloseTimer) clearTimeout(autoCloseTimer);
        autoCloseTimer = setTimeout(() => {
          isMenuOpen.value = false;
        }, 3000);
      } else if (autoCloseTimer) {
        clearTimeout(autoCloseTimer);
      }
    });
    const onMobileClick = () => {
      // Tap: popover aç ve güncelleme servisini çalıştır
      isMenuOpen.value = true;
      clickLimit();
    };

    // Limit tutarı değiştiğinde popover’ı göster
    watch(
      () => store.state.riskTutar,
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          isMenuOpen.value = true;
        }
      }
    );

    // Sepetteki ürün sayısı değiştiğinde popover’ı göster
    watch(
      () => store.state['app-order'] && store.state['app-order'].basketItemCount,
      (newVal, oldVal) => {
        if (newVal !== undefined && newVal !== oldVal) {
          isMenuOpen.value = true;
        }
      }
    );

    const clickLimit = () => {
      clickLimitStatus.value = true;
      store.dispatch("syncCustomerLimit").finally(() => {
        setTimeout(() => {
          clickLimitStatus.value = false;
        }, 1200);
      });
    };

    return {
      clickLimitStatus,
      showLimitLoading,
      isMenuOpen,
      onMobileClick,
      clickLimit,
      icons: {
        mdiFinance,
      },
    };
  },
};
</script>

<style>
.cursor-pointer {
  cursor: pointer;
}
.limit-avatar-wrapper {
  position: relative;
  display: inline-block;
}
.limit-overlay {
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 9px;
  line-height: 1;
  color: #ffffff;
  background:#28243d;
  padding: 2px 6px;
  border-radius: 8px;
  letter-spacing: 0.5px;
  border: 1px solid rgba(255,255,255,0.45);
  font-weight: 700;
  text-shadow: 0 1px 2px rgba(0,0,0,0.6);
  box-shadow: 0 1px 2px rgba(0,0,0,0.2);
  text-transform: uppercase;
  white-space: nowrap;
}
.limit-value {
  font-size: 18px;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.limit-menu-fixed {
  position: fixed !important;
  z-index: 2020 !important;
}
.no-shrink {
  flex-shrink: 0;
}
.limit-menu {
  overflow: hidden !important;
}
.limit-card {
  min-width: 210px;
  text-align: center;
}
.limit-row {
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}
.limit-spinner {
  margin-left: 8px;
  flex: 0 0 auto;
}
</style>
